import React, { useEffect, useState } from "react";
import { SignUpFormType } from "../../SignUpFormTypes/signUpFormTypes";
import FormProgress from "./FormProgress";
import FormPromoCodeMessage from "./FormPromoCodeMessage";
import FormContent from "./FormContent";
import SpLink from "./SpLink";
import GoBackButton from "./GoBackButton";
import { SignUpFormProvider } from "./SignUpFormContext";
import ClientPractitionerClient from "./ClientPractitionerClient";

const SignUpForm: React.FC<SignUpFormType> = ({
  promoCodeInfo,
  steps = [],
  lastStepCta,
  useSignUpFormStateMethods,
  includeClientPractitionerSelection,
  clientPractitionerSelection,
  onStepZeroClick,
  ...props
}) => {
  const { promoCode, isPartner } = promoCodeInfo;

  const { setSteps, getIsFirstStep, setLastStepCta } =
    useSignUpFormStateMethods;
  const [clientPractitionerStep, setClientPractitionerStep] = useState(
    !!includeClientPractitionerSelection
  );
  const advanceNextStep = (
    e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>
  ) => {
    const target = e.currentTarget as HTMLElement;
    const type = target.querySelector(
      ".client-practitioner__text"
    )!.textContent;

    if (type) {
      if (target instanceof HTMLAnchorElement) {
        onStepZeroClick(type, target.pathname);
      } else {
        onStepZeroClick(type, null);
        setClientPractitionerStep(false);
      }
    }
  };

  const isFirstStep = getIsFirstStep();

  useEffect(() => {
    setLastStepCta(lastStepCta);
  }, [lastStepCta, setLastStepCta]);

  useEffect(() => {
    if (steps.length === 0) return;
    setSteps(steps);
  }, [steps, setSteps]);

  const showPromoCodeMessage = isFirstStep && promoCode && isPartner;

  return (
    <>
      {clientPractitionerStep ? (
        <ClientPractitionerClient
          {...clientPractitionerSelection}
          advanceNextStep={advanceNextStep}
        />
      ) : (
        <SignUpFormProvider
          promoCode={promoCode}
          useSignUpFormStateMethods={useSignUpFormStateMethods}
          steps={steps}
          {...props}
        >
          <section
            className={`font-sans grid  w-[564px] sm:w-full md:w-[431px] sign-up--rebrand-container
            ${isFirstStep ? "sm:gap-6 gap-8" : "sm:gap-4 gap-6"}`}
          >
            <div
              className={`flex flex-col ${
                showPromoCodeMessage ? "gap-12 sm:gap-6" : "gap-12"
              }`}
            >
              <FormProgress />
              {showPromoCodeMessage && (
                <FormPromoCodeMessage promoCodeInfo={promoCodeInfo} />
              )}
              <FormContent />
            </div>
            {isFirstStep ? <SpLink /> : <GoBackButton />}
          </section>
        </SignUpFormProvider>
      )}
    </>
  );
};

export default SignUpForm;
